export const cacheServerURL = 'https://ethplorer-cache-vqck7.ondigitalocean.app/tokeninfo'